export const MAX_ALLOWED_CLIENT_VALIDATION_FILE_SIZE_BYTES = 0 * 1024 * 1024; // 0 MB
